// START IMPORTS
import { Stack } from '@ltvco/refresh-lib/theme';
import {
  ReportTypeOption,
  ReportType,
  ReportFilter,
  SortBy,
  SortDirection,
  SearchComponent,
  FiltersComponent,
  SortComponent,
} from '@ltvco/refresh-lib/v2';
// END IMPORTS

// START INTERFACES_AND_TYPES
type SearchAndFilterControlsProps = {
  setQueryParams: any;
  onSearchChange: (searchBy: string) => void;
  reportTypeFilterOptions: { [key: string]: ReportTypeOption };
  filterTypes: ReportType[];
  // eslint-disable-next-line no-unused-vars
  setFilterTypes: (reportTypes: ReportFilter[]) => void;
  sort_by: SortBy;
  sort_direction: SortDirection;
};
// END INTERFACES_AND_TYPES

export function SearchAndFilterControls({
  setQueryParams,
  onSearchChange,
  reportTypeFilterOptions,
  filterTypes,
  setFilterTypes,
  sort_by,
  sort_direction,
}: SearchAndFilterControlsProps) {
  // START RENDER
  return (
    <Stack direction={{ xl: 'row', xs: 'column' }} spacing={1.5}>
      <SearchComponent onSearchChange={onSearchChange} />
      <Stack direction="row" spacing={1.5}>
        <FiltersComponent
          reportTypeOptions={reportTypeFilterOptions}
          reportTypes={filterTypes}
          setReportTypes={setFilterTypes}
        />
        <SortComponent
          currentSort={{ sort_by, sort_direction }}
          setQueryParams={setQueryParams}
        />
      </Stack>
    </Stack>
  );
  // END RENDER
}
